import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/app.css';
import CreateERISARequest from './components/CreateERISARequest';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CreateERISARequest />
  </React.StrictMode>
);
